import api from '@/api'
import errors from '@/api/errors'
import store from '@/store'

const baseUrlRef = process.env.REVIEW_API_BASE_URL_REF

const createGetParams = (args) => {
  const p = {}
  p.accessToken = store.getters['commons/cookies'].mchat
  p.sessionID = store.getters['commons/cookies'].encsid
  p.jan = args.jan
  return p
}

const onReceived = (respBody) => {
  if (respBody.resultCode !== 0) {
    console.error(`API error code ${respBody.resultCode}`)
    if (respBody.resultCode === 611) { // アクセストークンエラー
      throw new errors.AuthenticationError()
    }
    throw new Error('問題が発生したためその後の処理を継続することができませんでした。時間を置いて再度利用をお願いします。')
  }
  return Promise.resolve({ items: respBody.items })
}

export default {
  // レビュー用購入履歴取得
  getPurchase: (args) => {
    const params = createGetParams(args)
    return api.post(`${baseUrlRef}/getReviewPurchaseHistory`, params).then(onReceived)
  }
}



// WEBPACK FOOTER //
// ./src/api/purchase.js